import apiClient from './client'

export { authApi } from './auth'
export { customersApi } from './customers'
export { offersApi } from './offers'

// Moduli restanti - esposti come wrapper leggeri sull'apiClient.
// Verranno tipizzati completamente quando si migra ogni modulo.

export const branchesApi = {
  getAll: () => apiClient.get('/branches').then((r) => r.data),
  getWithStats: () => apiClient.get('/branches/with-stats').then((r) => r.data),
  getById: (id: string) => apiClient.get(`/branches/${id}`).then((r) => r.data),
  create: (data: Record<string, unknown>) => apiClient.post('/branches', data).then((r) => r.data),
  update: (id: string, data: Record<string, unknown>) => apiClient.put(`/branches/${id}`, data),
  delete: (id: string) => apiClient.delete(`/branches/${id}`),
  assignEmployee: (branchId: string, employeeId: string) => apiClient.post(`/branches/${branchId}/employees/${employeeId}`),
  setManager: (branchId: string, managerEmployeeId: string) => apiClient.put(`/branches/${branchId}/manager`, { managerEmployeeId }),
  uploadLogo: (branchId: string, file: File) => {
    const formData = new FormData()
    formData.append('file', file)
    return apiClient.post(`/branches/${branchId}/logo`, formData).then((r) => r.data)
  },
}

export const employeesApi = {
  getAll: () => apiClient.get('/employees').then((r) => r.data),
  getById: (id: string) => apiClient.get(`/employees/${id}`).then((r) => r.data),
  create: (data: Record<string, unknown>) => apiClient.post('/employees', data).then((r) => r.data),
  update: (id: string, data: Record<string, unknown>) => apiClient.put(`/employees/${id}`, data),
  deactivate: (id: string) => apiClient.post(`/employees/${id}/deactivate`),
  activate: (id: string) => apiClient.post(`/employees/${id}/activate`),
  getPermissions: (id: string) => apiClient.get(`/employees/${id}/permissions`).then((r) => r.data),
  updatePermissions: (id: string, permissions: Record<string, unknown>) => apiClient.put(`/employees/${id}/permissions`, permissions),
}

export const statisticsApi = {
  getDashboard: (params?: Record<string, unknown>) => apiClient.get('/statistics/dashboard', { params }).then((r) => r.data),
  getProperties: (from?: string, to?: string) => apiClient.get('/statistics/properties', { params: { from, to } }).then((r) => r.data),
  getPropertyTrend: (months = 6) => apiClient.get('/statistics/properties/insertion-trend', { params: { months } }).then((r) => r.data),
  getAgentPerformance: (from?: string, to?: string) => apiClient.get('/statistics/performance/agents', { params: { from, to } }).then((r) => r.data),
}

export const notificationsApi = {
  getAll: (limit = 50) => apiClient.get('/notifications', { params: { limit } }).then((r) => r.data),
  markAsRead: (id: string) => apiClient.put(`/notifications/${id}/read`),
  markAllAsRead: () => apiClient.put('/notifications/mark-all-read'),
  getUnreadCount: () => apiClient.get('/notifications/unread-count').then((r) => r.data),
}

export const searchApi = {
  global: (query: string, filters?: Record<string, unknown>) => apiClient.post('/search', { query, ...filters }).then((r) => r.data),
}

export const documentsApi = {
  getAllDocuments: (params?: { search?: string; category?: string }) =>
    apiClient.get('/documents', { params }).then((r) => r.data),
  getStats: () => apiClient.get('/documents/stats').then((r) => r.data),
  delete: (id: string) => apiClient.delete(`/documents/${id}`),
  getUnverified: () => apiClient.get('/documents/unverified').then((r) => r.data),
  getExpiring: (daysAhead = 30) => apiClient.get('/documents/expiring', { params: { daysAhead } }).then((r) => r.data),
  getExpired: () => apiClient.get('/documents/expired').then((r) => r.data),
  verify: (documentId: string) => apiClient.post(`/documents/${documentId}/verify`),
  unverify: (documentId: string) => apiClient.post(`/documents/${documentId}/unverify`),
}

// Registro attività di agenzia (GET /api/activity) - scoped alla propria
// agenzia, a differenza di adminApi.systemLogs (cross-tenant, SuperAdmin only).
export const activityApi = {
  getAll: (params?: Record<string, unknown>) => apiClient.get('/activity', { params }).then((r) => r.data),
  export: (params?: Record<string, unknown>) => apiClient.get('/activity/export', { params, responseType: 'blob' }),
}

export default apiClient
